import { format, parseISO, isValid } from "date-fns";

export const formatDate = (dateValue: string | Date | null | undefined) => {
  if (!dateValue || dateValue === "") {
    return "--";
  }
  try {
    const date =
      typeof dateValue === "string" ? parseISO(dateValue) : dateValue;

    if (!isValid(date)) {
      return "--";
    }
    return format(date, "MMM d, yyyy 'at' h:mm a");
  } catch (error) {
    return "--";
  }
};
export const formatStatus = (status: string) => {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
